import { Box, styled } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import { DataGrid } from '@mui/x-data-grid';
import { DarkmodeColors } from 'app/constants/color';

const CustomDiv = styled(Box)({
  height: '100%',
  width: '100%',
});

const MyTablePagination = styled(TablePagination)({
  font: 'DM Sans',
  fontSize: '30px',
});

const CustomDataGrid = styled(DataGrid)({
  fontSize: '16px',
  border: 'none',
  overflowX: 'hidden',
  '& .MuiCheckbox-root svg': {
    outline: 'none',
    width: 16,
    height: 16,
    backgroundColor: 'transparent',
    color: 'transparent',
    border: '1px solid #526380',
    borderRadius: 4,
  },
  '& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg': {
    color: '#D68F1D',
    // fontSize: '4rem',
    border: 'transparent',
    transform: 'scale(1.25)',
  },
  '&>.MuiDataGrid-main': {
    '&>.MuiDataGrid-columnHeaders': {
      border: 'none',
      padding: '0px 15px',
      backgroundColor: '#FFF8ED',
      color: DarkmodeColors.menuIcon,
      // border: '1px solid red',

      '& .MuiDataGrid-columnSeparator': {
        display: 'none',
      },
      fontWeight: '500',
      fontSize: '14px',
      lineHieght: '18px',
    },
    '&>.MuiDataGrid-cellCheckbox': {
      border: 'none',
      outline: 'none',
    },
    '& div div div div >.MuiDataGrid-cell': {
      border: 'none',
      borderBottom: 'none',
      outline: 'none',
    },
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #F9E5C5',
      width: '100%',
      padding: '0px 15px 0px 15px',
      '&>.MuiDataGrid-cellCheckbox': {
        display: 'flex',
        alignItems: 'start',
        padding: '8px 0 0 0',
      },
    },
    '& .MuiDataGrid-footerContainer': {
      height: '100px',
    },
  },
  '&.MuiDataGrid-root .MuiDataGrid-columnHeader, .MuiDataGrid-cell:focus, .MuiDataGrid-cellCheckbox:focus':
    {
      outline: 'none',
    },
});

const DarkmodeCustomDataGrid = styled(DataGrid)({
  fontSize: '0.8em',
  border: 'none',
  '& .MuiCheckbox-root svg': {
    outline: 'none',
    width: 16,
    height: 16,
    backgroundColor: 'transparent',
    color: 'transparent',
    border: `1px solid ${DarkmodeColors.menuIcon}`,
    borderRadius: 4,
  },
  '& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg': {
    color: '#D68F1D',
    // fontSize: '4rem',
    border: 'transparent',
    transform: 'scale(1.25)',
  },
  '&>.MuiDataGrid-main': {
    '&>.MuiDataGrid-columnHeaders': {
      border: 'none',
      padding: '0px 15px',
      backgroundColor: DarkmodeColors.datagridTableHeader,
      '& .MuiDataGrid-columnSeparator': {
        display: 'none',
      },
      color: DarkmodeColors.darkText,
      fontWeight: '500',
      fontSize: '0.8em',
      lineHieght: '18px',
    },
    '&>.MuiDataGrid-cellCheckbox': {
      border: 'none',
      outline: 'none',
    },
    '& div div div div >.MuiDataGrid-cell': {
      border: 'none',
      borderBottom: 'none',
      outline: 'none',
    },
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #526380',
      width: '100%',
      // margin: '0px 15px',
      padding: '0px 15px 0px 15px',
      '&>.MuiDataGrid-cellCheckbox': {
        display: 'flex',
        alignItems: 'start',
        padding: '8px 0 0 0',
      },
    },
    '& .MuiDataGrid-footer': {
      marginTop: '20px',
    },
  },
  '&.MuiDataGrid-root .MuiDataGrid-columnHeader, .MuiDataGrid-cell:focus, .MuiDataGrid-cellCheckbox:focus':
    {
      outline: 'none',
    },
  '& .MuiDataGrid-sortIcon': {
    color: 'white',
  },
});

export { CustomDiv, CustomDataGrid, DarkmodeCustomDataGrid, MyTablePagination };
